import { memo } from "react";
import { Skeleton } from "@/components/ui/skeleton";

const AuctionCardSkeleton = memo(() => {
  return (
    <div className="rounded-xl border border-border/50 bg-secondary/30 backdrop-blur-sm overflow-hidden">
      <div className="p-3 sm:p-4">
        {/* Header with item icon and name */}
        <div className="flex items-start gap-2.5 sm:gap-3 mb-2.5 sm:mb-3">
          <Skeleton className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex-shrink-0" />
          <div className="flex-1 min-w-0 space-y-1.5">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        </div>
        
        {/* Seller and time */}
        <div className="space-y-1.5 sm:space-y-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.5">
              <Skeleton className="w-3.5 h-3.5 sm:w-4 sm:h-4 rounded-full" />
              <Skeleton className="h-3 w-16 sm:w-20" />
            </div>
            <Skeleton className="h-3 w-12 sm:w-14" />
          </div>
          
          {/* Price section */}
          <div className="flex items-center justify-between pt-1.5 sm:pt-2 border-t border-border/30">
            <Skeleton className="h-3 w-20" />
            <div className="flex items-center gap-1.5">
              <Skeleton className="w-3 h-3 rounded-full" />
              <Skeleton className="h-4 w-14 sm:w-16" />
            </div>
          </div>
          
          {/* Bid count */}
          <Skeleton className="h-3 w-16" />
        </div>
      </div>
    </div>
  );
});

AuctionCardSkeleton.displayName = 'AuctionCardSkeleton';

export default AuctionCardSkeleton;
